export default function Brunch() {
  return (
    <section id="brunch" className="py-12 md:py-20 bg-gradient-to-b from-white to-[#FFF8F5]">
      <div className="container mx-auto px-4 md:px-6">
        {/* Header */}
        <div className="text-center mb-8 md:mb-16">
          <div className="inline-block bg-[#4A7C59] text-white px-4 md:px-8 py-2 md:py-3 rounded-full text-xs md:text-sm font-bold mb-4 md:mb-6 whitespace-nowrap">
            BRUNCH & DÉJEUNER 🥐
          </div>
          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-black text-[#2C3E50] mb-4 md:mb-6 px-4">
            Une Expérience <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#FF8F6B] to-[#4A7C59]">Unique</span> à La Réunion
          </h2>
          <p className="text-base md:text-xl text-gray-600 max-w-3xl mx-auto px-4">
            Le Bocal Givré, c'est bien plus qu'un restaurant. C'est un <strong className="text-[#4A7C59]">lieu de vie</strong> où se mêlent 
            saveurs créoles et cuisine du monde, cocktails créatifs et ambiance tropicale. 
            Venez découvrir notre univers <strong className="text-[#FF8F6B]">coloré et chaleureux</strong>, où chaque visite devient un moment inoubliable.
          </p>
        </div>

        {/* Le Concept Section - Gen Z Style */}
        <div className="mb-16 md:mb-24">
          {/* Video + Formule Side by Side - Desktop Only */}
          <div className="hidden lg:grid lg:grid-cols-2 gap-8 xl:gap-12 items-start mb-16">
            {/* Video Side */}
            <div className="relative h-full">
              <div className="relative h-full">
                {/* Decorative background blob */}
                <div className="absolute -inset-4 bg-gradient-to-br from-[#FF8F6B]/20 via-[#4A7C59]/20 to-[#FF8F6B]/20 rounded-[3rem] blur-2xl"></div>
                
                <div className="relative w-full h-full flex items-center justify-center">
                  <div className="w-full max-w-md aspect-[9/16] rounded-3xl overflow-hidden shadow-2xl border-4 border-[#FF8F6B]">
                    <iframe 
                      allow="fullscreen;autoplay" 
                      allowFullScreen 
                      height="100%" 
                      src="https://streamable.com/e/ug1t7x?autoplay=1&muted=1" 
                      width="100%" 
                      className="w-full h-full"
                      style={{ border: 'none', position: 'absolute', left: 0, top: 0, overflow: 'hidden', pointerEvents: 'none' }}
                    ></iframe>
                  </div>
                  
                  {/* Floating emojis */}
                  <div className="absolute -top-6 -left-6 text-5xl animate-bounce">🌺</div>
                  <div className="absolute -top-6 -right-6 text-5xl animate-bounce" style={{ animationDelay: '0.1s' }}>🍹</div>
                  <div className="absolute -bottom-6 -left-6 text-5xl animate-bounce" style={{ animationDelay: '0.2s' }}>🥥</div>
                  <div className="absolute -bottom-6 -right-6 text-5xl animate-bounce" style={{ animationDelay: '0.3s' }}>🌴</div>
                </div>
              </div>
            </div>

            {/* Formule Unique Card - Desktop */}
            <div className="bg-white rounded-2xl md:rounded-3xl p-6 md:p-8 shadow-2xl border-4 border-[#4A7C59]/20 hover:border-[#FF8F6B] transition-colors h-full flex flex-col justify-center">
              <h3 className="text-2xl md:text-3xl font-black text-[#4A7C59] mb-4 md:mb-6 flex items-center gap-3">
                <span className="text-3xl md:text-4xl">🍴</span>
                Le Brunch Comprend
              </h3>

              <div className="space-y-3 md:space-y-4 mb-6 md:mb-8">
                <div className="flex items-center gap-3 md:gap-4 p-3 md:p-4 bg-[#F5E6D3]/50 rounded-xl hover:bg-[#F5E6D3] transition-colors">
                  <div className="w-10 h-10 md:w-12 md:h-12 bg-[#4A7C59] rounded-full flex items-center justify-center text-white text-lg md:text-xl flex-shrink-0">
                    ✓
                  </div>
                  <p className="text-[#4A7C59] font-semibold text-sm md:text-lg">Pancakes, pain perdu, pains, céréales</p>
                </div>
                
                <div className="flex items-center gap-3 md:gap-4 p-3 md:p-4 bg-[#F5E6D3]/50 rounded-xl hover:bg-[#F5E6D3] transition-colors">
                  <div className="w-10 h-10 md:w-12 md:h-12 bg-[#4A7C59] rounded-full flex items-center justify-center text-white text-lg md:text-xl flex-shrink-0">
                    ✓
                  </div>
                  <p className="text-[#4A7C59] font-semibold text-sm md:text-lg">Boissons chaudes</p>
                </div>
                
                <div className="flex items-center gap-3 md:gap-4 p-3 md:p-4 bg-[#F5E6D3]/50 rounded-xl hover:bg-[#F5E6D3] transition-colors">
                  <div className="w-10 h-10 md:w-12 md:h-12 bg-[#4A7C59] rounded-full flex items-center justify-center text-white text-lg md:text-xl flex-shrink-0">
                    ✓
                  </div>
                  <p className="text-[#4A7C59] font-semibold text-sm md:text-lg">Salades & tapenades</p>
                </div>

                <div className="flex items-center gap-3 md:gap-4 p-3 md:p-4 bg-[#F5E6D3]/50 rounded-xl hover:bg-[#F5E6D3] transition-colors">
                  <div className="w-10 h-10 md:w-12 md:h-12 bg-[#4A7C59] rounded-full flex items-center justify-center text-white text-lg md:text-xl flex-shrink-0">
                    ✓
                  </div>
                  <p className="text-[#4A7C59] font-semibold text-sm md:text-lg">Charcuterie & fromages</p>
                </div>

                <div className="flex items-center gap-3 md:gap-4 p-3 md:p-4 bg-[#F5E6D3]/50 rounded-xl hover:bg-[#F5E6D3] transition-colors">
                  <div className="w-10 h-10 md:w-12 md:h-12 bg-[#4A7C59] rounded-full flex items-center justify-center text-white text-lg md:text-xl flex-shrink-0">
                    ✓
                  </div>
                  <p className="text-[#4A7C59] font-semibold text-sm md:text-lg">2 jus</p>
                </div>

                <div className="flex items-center gap-3 md:gap-4 p-3 md:p-4 bg-[#F5E6D3]/50 rounded-xl hover:bg-[#F5E6D3] transition-colors">
                  <div className="w-10 h-10 md:w-12 md:h-12 bg-[#4A7C59] rounded-full flex items-center justify-center text-white text-lg md:text-xl flex-shrink-0">
                    ✓
                  </div>
                  <p className="text-[#4A7C59] font-semibold text-sm md:text-lg">3 desserts différents</p>
                </div>

                <div className="flex items-center gap-3 md:gap-4 p-3 md:p-4 bg-[#F5E6D3]/50 rounded-xl hover:bg-[#F5E6D3] transition-colors">
                  <div className="w-10 h-10 md:w-12 md:h-12 bg-[#4A7C59] rounded-full flex items-center justify-center text-white text-lg md:text-xl flex-shrink-0">
                    ✓
                  </div>
                  <p className="text-[#4A7C59] font-semibold text-sm md:text-lg">3 plats chauds</p>
                </div>
              </div>

              {/* Schedule */}
              <div className="bg-gradient-to-r from-[#4A7C59] to-[#3d6849] rounded-xl md:rounded-2xl p-5 md:p-6 text-white">
                <div className="flex items-center justify-between mb-3">
                  <p className="text-lg md:text-xl font-black">🗓 Samedi & Dimanche</p>
                  <span className="text-2xl md:text-3xl">⏰</span>
                </div>
                <p className="text-xl md:text-2xl font-black mb-1">Service 1 : 10h à 12h</p>
                <p className="text-xl md:text-2xl font-black mb-3">Service 2 : 13h à 15h</p>
                
                <div className="border-t border-white/30 my-3 pt-3">
                  <p className="text-lg md:text-xl font-black mb-1">🗓 Lundi</p>
                  <p className="text-xl md:text-2xl font-black">11h à 14h</p>
                </div>
              </div>
            </div>
          </div>

          {/* Mobile/Tablet Version - Video + Formule Stacked */}
          <div className="lg:hidden mb-12">
            {/* Video Mobile */}
            <div className="max-w-sm md:max-w-md mx-auto px-4 mb-8">
              <div className="relative">
                <div className="w-full aspect-[9/16] rounded-2xl md:rounded-3xl overflow-hidden shadow-2xl border-2 md:border-4 border-[#FF8F6B]">
                  <iframe 
                    allow="fullscreen;autoplay" 
                    allowFullScreen 
                    height="100%" 
                    src="https://streamable.com/e/ug1t7x?autoplay=1&muted=1" 
                    width="100%" 
                    className="w-full h-full"
                    style={{ border: 'none', position: 'absolute', left: 0, top: 0, overflow: 'hidden', pointerEvents: 'none' }}
                  ></iframe>
                </div>
                
                {/* Decorative elements */}
                <div className="absolute -top-2 -left-2 md:-top-3 md:-left-3 text-xl md:text-3xl animate-bounce">🌺</div>
                <div className="absolute -top-2 -right-2 md:-top-3 md:-right-3 text-xl md:text-3xl animate-bounce delay-100">🍹</div>
                <div className="absolute -bottom-2 -left-2 md:-bottom-3 md:-left-3 text-xl md:text-3xl animate-bounce delay-200">🥥</div>
                <div className="absolute -bottom-2 -right-2 md:-bottom-3 md:-right-3 text-xl md:text-3xl animate-bounce delay-300">🌴</div>
              </div>
            </div>

            {/* Formule Unique Card - Mobile */}
            <div className="bg-white rounded-2xl md:rounded-3xl p-6 md:p-8 shadow-2xl border-4 border-[#4A7C59]/20 hover:border-[#FF8F6B] transition-colors max-w-md mx-auto">
              <h3 className="text-2xl md:text-3xl font-black text-[#4A7C59] mb-4 md:mb-6 flex items-center gap-3">
                <span className="text-3xl md:text-4xl">🍴</span>
                Le Brunch Comprend
              </h3>

              <div className="space-y-3 md:space-y-4 mb-6 md:mb-8">
                <div className="flex items-center gap-3 md:gap-4 p-3 md:p-4 bg-[#F5E6D3]/50 rounded-xl hover:bg-[#F5E6D3] transition-colors">
                  <div className="w-10 h-10 md:w-12 md:h-12 bg-[#4A7C59] rounded-full flex items-center justify-center text-white text-lg md:text-xl flex-shrink-0">
                    ✓
                  </div>
                  <p className="text-[#4A7C59] font-semibold text-sm md:text-lg">Pancakes, pain perdu, pains, céréales</p>
                </div>
                
                <div className="flex items-center gap-3 md:gap-4 p-3 md:p-4 bg-[#F5E6D3]/50 rounded-xl hover:bg-[#F5E6D3] transition-colors">
                  <div className="w-10 h-10 md:w-12 md:h-12 bg-[#4A7C59] rounded-full flex items-center justify-center text-white text-lg md:text-xl flex-shrink-0">
                    ✓
                  </div>
                  <p className="text-[#4A7C59] font-semibold text-sm md:text-lg">Boissons chaudes</p>
                </div>
                
                <div className="flex items-center gap-3 md:gap-4 p-3 md:p-4 bg-[#F5E6D3]/50 rounded-xl hover:bg-[#F5E6D3] transition-colors">
                  <div className="w-10 h-10 md:w-12 md:h-12 bg-[#4A7C59] rounded-full flex items-center justify-center text-white text-lg md:text-xl flex-shrink-0">
                    ✓
                  </div>
                  <p className="text-[#4A7C59] font-semibold text-sm md:text-lg">Salades & tapenades</p>
                </div>

                <div className="flex items-center gap-3 md:gap-4 p-3 md:p-4 bg-[#F5E6D3]/50 rounded-xl hover:bg-[#F5E6D3] transition-colors">
                  <div className="w-10 h-10 md:w-12 md:h-12 bg-[#4A7C59] rounded-full flex items-center justify-center text-white text-lg md:text-xl flex-shrink-0">
                    ✓
                  </div>
                  <p className="text-[#4A7C59] font-semibold text-sm md:text-lg">Charcuterie & fromages</p>
                </div>

                <div className="flex items-center gap-3 md:gap-4 p-3 md:p-4 bg-[#F5E6D3]/50 rounded-xl hover:bg-[#F5E6D3] transition-colors">
                  <div className="w-10 h-10 md:w-12 md:h-12 bg-[#4A7C59] rounded-full flex items-center justify-center text-white text-lg md:text-xl flex-shrink-0">
                    ✓
                  </div>
                  <p className="text-[#4A7C59] font-semibold text-sm md:text-lg">2 jus</p>
                </div>

                <div className="flex items-center gap-3 md:gap-4 p-3 md:p-4 bg-[#F5E6D3]/50 rounded-xl hover:bg-[#F5E6D3] transition-colors">
                  <div className="w-10 h-10 md:w-12 md:h-12 bg-[#4A7C59] rounded-full flex items-center justify-center text-white text-lg md:text-xl flex-shrink-0">
                    ✓
                  </div>
                  <p className="text-[#4A7C59] font-semibold text-sm md:text-lg">3 desserts différents</p>
                </div>

                <div className="flex items-center gap-3 md:gap-4 p-3 md:p-4 bg-[#F5E6D3]/50 rounded-xl hover:bg-[#F5E6D3] transition-colors">
                  <div className="w-10 h-10 md:w-12 md:h-12 bg-[#4A7C59] rounded-full flex items-center justify-center text-white text-lg md:text-xl flex-shrink-0">
                    ✓
                  </div>
                  <p className="text-[#4A7C59] font-semibold text-sm md:text-lg">3 plats chauds</p>
                </div>
              </div>

              {/* Schedule */}
              <div className="bg-gradient-to-r from-[#4A7C59] to-[#3d6849] rounded-xl md:rounded-2xl p-5 md:p-6 text-white">
                <div className="flex items-center justify-between mb-3">
                  <p className="text-lg md:text-xl font-black">🗓 Samedi & Dimanche</p>
                  <span className="text-2xl md:text-3xl">⏰</span>
                </div>
                <p className="text-xl md:text-2xl font-black mb-1">Service 1 : 10h à 12h</p>
                <p className="text-xl md:text-2xl font-black mb-3">Service 2 : 13h à 15h</p>
                
                <div className="border-t border-white/30 my-3 pt-3">
                  <p className="text-lg md:text-xl font-black mb-1">🗓 Lundi</p>
                  <p className="text-xl md:text-2xl font-black">11h à 14h</p>
                </div>
              </div>
            </div>
          </div>

          {/* Separator */}
          <div className="relative py-8 md:py-12">
            <div className="absolute inset-0 flex items-center">
              <div className="w-full border-t-2 border-dashed border-[#FF8F6B]/30"></div>
            </div>
            <div className="relative flex justify-center">
              <span className="bg-gradient-to-b from-white to-[#FFF8F5] px-6 text-4xl">✨</span>
            </div>
          </div>

          {/* Concept Features */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 max-w-6xl mx-auto">
            <div className="group relative bg-white rounded-2xl p-6 md:p-8 shadow-lg hover:shadow-2xl transition-all hover:-translate-y-2 border-2 border-transparent hover:border-[#4A7C59]">
              <div className="absolute -top-4 -right-4 w-12 h-12 bg-gradient-to-br from-[#4A7C59] to-[#3d6849] rounded-full flex items-center justify-center text-2xl shadow-lg">
                🍽️
              </div>
              <h4 className="text-xl md:text-2xl font-bold text-[#2C3E50] mb-3 mt-2">Cuisine Créole & du Monde</h4>
              <p className="text-sm md:text-base text-gray-600 leading-relaxed">
                Des saveurs créoles authentiques et une cuisine internationale pour satisfaire tous les goûts
              </p>
            </div>
            
            <div className="group relative bg-white rounded-2xl p-6 md:p-8 shadow-lg hover:shadow-2xl transition-all hover:-translate-y-2 border-2 border-transparent hover:border-[#FF8F6B]">
              <div className="absolute -top-4 -right-4 w-12 h-12 bg-gradient-to-br from-[#FF8F6B] to-[#ff6b47] rounded-full flex items-center justify-center text-2xl shadow-lg">
                🍹
              </div>
              <h4 className="text-xl md:text-2xl font-bold text-[#2C3E50] mb-3 mt-2">Bar Créatif</h4>
              <p className="text-sm md:text-base text-gray-600 leading-relaxed">
                Créez vos propres cocktails avec nos mixologues
              </p>
            </div>
            
            <div className="group relative bg-white rounded-2xl p-6 md:p-8 shadow-lg hover:shadow-2xl transition-all hover:-translate-y-2 border-2 border-transparent hover:border-[#4A7C59]">
              <div className="absolute -top-4 -right-4 w-12 h-12 bg-gradient-to-br from-[#4A7C59] to-[#3d6849] rounded-full flex items-center justify-center text-2xl shadow-lg">
                🌴
              </div>
              <h4 className="text-xl md:text-2xl font-bold text-[#2C3E50] mb-3 mt-2">Ambiance Tropicale</h4>
              <p className="text-sm md:text-base text-gray-600 leading-relaxed">
                Un cadre chaleureux et coloré pour se détendre
              </p>
            </div>
          </div>
        </div>

        {/* Brunch Menu Grid */}
        {/* Section supprimée */}

        {/* Horaires & Tarifs */}
      </div>
    </section>
  );
}